<template>
  <div class="calc-error">
    <div class="calc-error__container">
      <span>Внутренняя ошибка сервера</span>
      <button @click="$emit('close')">ок</button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CalcError',
  emits: 'close',
})
</script>

<style lang="scss" scoped>
.calc-error {
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(255, 255, 255, 0.25);

  display: flex;
  align-items: center;
  justify-content: center;

  &__container {
    padding: 20px 48px;
    border-radius: 4px;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 28px;

    button {
      border-radius: 4px;
      color: #2396ca;
      background-color: #fff;
      border: thin solid #2396ca;
      height: 36px;
      padding: 0 32px;
      cursor: pointer;
      text-transform: uppercase;
      transition: all 0.2s;
      font-size: 14px;
      font-weight: 500;

      &:hover {
        background-color: #eef7fb;
      }
    }
  }
}
</style>
